module.exports = __webpack_public_path__ + "img/69600.feea716e.jpg";